import React, { useState } from "react";
import { useScreenSize } from "../../hooks/useScreenSize";
import Button from "../../components/button";
import StepCard from "../../components/step-card";
import { steps } from './db';
import { api } from "../../services/api";
import { onDataLayer } from '../../services/use-data-layer';
import ReactHtmlParser from "react-html-parser";
import { scroller } from "react-scroll";

import Modal from "../../components/modal";

import * as S from "./styles";

const SectionSteps = () => {
	const KEY_STORAGE = 'ESTACIO_FORTNITE';
	const KEY_STORAGE_LOG = '@ESTACIO_FORTNITE';

	const dimension = useScreenSize();
  const [number, setNumber] = useState("");

  const [openModal, setOpenModal] = useState(false);
	const [modalMessage, setModalMessage] = useState(null);

  const [openModalMission, setOpenModalMission] = useState(false);
	const [modalMission, setModalMission] = useState(null);

	const [code, setCode] = useState(false);

  const onOpenModalMission = () => {
    const user = localStorage.getItem(KEY_STORAGE_LOG) || null;
    const logged = JSON.parse(user);
    
    if (logged) {
      setModalMission(`
        <p>Aqui está seu código de acesso ao Expedição ENEMVERSO. Entre no Fortnite no modo criativo, complete os mapas e concorra a bolsas de ensino.</p>
        <p>Código: 1138-6550-4225</p>
      `);
      setOpenModalMission(true);
    } else {
      setModalMission(`<p>Ops, para pegar o código do jogo você precisa se cadastrar e estar logado.</p> `);
      setOpenModalMission(true);
    }
  };

  const onSubmit = async (event) => {
		event.preventDefault();

    const userData = localStorage.getItem(KEY_STORAGE) || null;
		const email = JSON.parse(userData);

    const user = localStorage.getItem(KEY_STORAGE_LOG) || null;
    const logged = JSON.parse(user);

		if (email && number && logged) {
      const response = await api.post('/participante', {
        email: email,
        codigo: number
      });
      
      if (response.data.status !== "OK") {
        setModalMessage(`<p>${response.data.mensagem}</p>`);
        setOpenModal(true);

        // Push DataLayer erro
        onDataLayer(response.data.status, response.status, 'erro-salvar-codigo-do-jogo', response.data.mensagem);
        setCode(false);
      } else {
        setModalMessage(`<p>${response.data.mensagem}</p>`);
        setOpenModal(true);
        
        // Push DataLayer sucesso
        onDataLayer(response.data.status, response.status, 'sucesso-salvar-codigo-do-jogo', response.data.mensagem);
        setCode(true);
      }

		} else {
      setModalMessage(`<p>Ops, para pegar o número da sorte você precisa se cadastrar e estar logado.</p> `);
      setOpenModal(true);
		}
  };

  const onCloseModal = () => {
    setOpenModal(false);
    setNumber("");

    if (number && !code) {
      return scroller.scrollTo("toRegister", { smooth: true });
    } else {
      return;
    }
	};

  return (
    <S.SectionSteps id="toSteps" data-section="section_passo-a-passo">
      <div className="container">
        <h2 className="title title-section">Confira o passo a passo para participar!</h2>

        <div className="steps-container">
          {steps.map(step => <StepCard title={step.title} key={step.title} description={step.description} />)}
        </div>

        <p className="note-prizes">
          <b>Distribuição Gratuita de Prêmios</b>. Válida para pessoa física com CPF,
          estudante com o Ensino Médio completo ou que concluir até abril de 2023.
          Antes de participar, leia o regulamento completo em enemverso.estacio.br.
          <b>CERTIFICADO DE AUTORIZAÇÃO SEAE/ME Nº 04.023271/2022</b>
        </p>
          <Button
            label="ACEITAR MISSÃO"
            fontSize={dimension.width >= 1024 ? "23" : "20"}
            height='86'
            width={dimension.width >= 1024 ? "414" : "222"}
            padding={dimension.width >= 1024 ? "0" : "25"}
            weight={900}
            dataElement="button_aceitar_missao"
            action={onOpenModalMission}
          />

        <div className="lucky-number">
          <h2 className="title">Já completou os desafios? Insira aqui o código secreto da semana e concorra ao sorteio.</h2>
          <form onSubmit={(e) => onSubmit(e)} method="post">
            <input
              required
              placeholder="Inserir o código secreto"
              className="code-input"
              type="text" 
              name="code" 
              id="code"
              onChange={(e) => setNumber(e.target.value)}
              value={number}
              data-element="input_codigo-secreto"
            />
            <Button
              label={dimension.width >= 1024 ? "PEGAR NÚMERO DA SORTE" : "RESGATAR CÓDIGO"}
              fontSize={dimension.width >= 1024 ? "23" : "18"}
              height='76'
              width={dimension.width >= 1024 ? "359" : "234"}
              padding={dimension.width >= 1024 ? "0" : "25"}
              weight={900}
              action={() => null}
              dataElement="button_pegar-numero-da-sorte"
            />
          </form>
        </div>
      </div>

      <Modal isOpen={openModal} onClose={onCloseModal}>
				{ReactHtmlParser(modalMessage)}
			</Modal>

      <Modal isOpen={openModalMission} onClose={() => setOpenModalMission(false)}>
				{ReactHtmlParser(modalMission)}
			</Modal>

    </S.SectionSteps>
  )
}

export default SectionSteps